import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as ArrowForwardIosIcon } from "../../assets/icons/nextArrow.svg";
import { ReactComponent as ArrowBackIosIcon } from "../../assets/icons/prevArrow.svg";
import styled from "styled-components";
import { PRIMARY, SECONDARY } from "../../const/colors";
import {
  ContentCardImage,
  MultiItemscolumn,
  MultiItemsCard,
  WitgetContainer,
  Span,
  NotAvailable,
} from "./Banner2Elements";

import LoaderFull from "../LoaderFull";
import axios from "axios";
import DetailModal from "../bonos2/DetailModal ";
import { API_URL } from "../../const/api";
import { useTranslation } from "react-i18next";

const StyledSlider = styled(Slider)`
  max-height: ${(props) => props.size};
  position: "relative";

  @media screen and (min-width: 1800px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "550px"
        : props.main === "home 2"
        ? "290px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1500px) and (max-width: 1799px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "450px"
        : props.main === "home 2"
        ? "220px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1300px) and (max-width: 1499px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "420px"
        : props.main === "home 2"
        ? "200px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1080px) and (max-width: 1299px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "400px"
        : props.main === "home 2"
        ? "180px"
        : `calc(${props.size})`};
  }
  /* @media screen and (max-width: 1199px) {
		min-height: ${(props) => `calc(${props.size})`};
	} */
  @media screen and (max-width: 600px) {
    & .slick-list{
      padding: 0!important;
			overflow: unset;
			transform: translate(-10px, 0px) !important;
    }
  }
`;

const ForwardIcon = styled(ArrowForwardIosIcon)`
  border: 1px solid ${PRIMARY};
  padding: 7px;
  transition: all 0.3s ease-in-out 0s;
  width: 50px !important;
  height: 40px !important;
  background: ${SECONDARY};
  path {
    stroke: #fff;
    transition: all 0.3s ease-in-out 0s;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }
  &:hover {
    background: ${SECONDARY};
  }
`;

const BackIcon = styled(ArrowBackIosIcon)`
  border: 1px solid ${PRIMARY};
  padding: 7px;
  transition: all 0.3s ease-in-out 0s;
  width: 50px !important;
  height: 40px !important;
  background: ${SECONDARY};
  path {
    stroke: #fff;
    transition: all 0.3s ease-in-out 0s;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }
  &:hover {
    background: ${SECONDARY};
  }
`;

const CustomDot = styled.div`
  width: 25px;
  height: 5px;
  background-color: #fff;
  position: absolute;
  bottom: 1.6rem;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: ${PRIMARY};
  }

  @media screen and (max-width: 1080px) {
    bottom: 1.5rem;
  }
`;

const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);
const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);

const Banner2 = (props) => {
  const settings = {
    dots: props.indicators,
    fade: props.fade,
    infinite: true,
    speed: 500,
    slidesToShow: props.show,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: props.time,
    cssEase: "ease-in-out",
    swipeToSlide:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
    prevArrow: (
      <PrevArrow>
        <BackIcon active={props.indicators ? 0 : 1} />
      </PrevArrow>
    ),
    nextArrow: (
      <NextArrow>
        <ForwardIcon active={props.indicators ? 0 : 1} />
      </NextArrow>
    ),
    customPaging: (i) => {
      return <CustomDot />;
    },
  };
  const [promotions, setPromotions] = useState([]);
  const [selectedPromotion, setSelectedPromotion] = useState(null);
  const [selectedPromotionIndex, setSelectedPromotionIndex] = useState(null);

  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    const loadPromociones = async () => {
      try {
        const response = await axios.post(
          API_URL+"loadPromociones"
        );
        console.log(response);

        // Filtrar las promociones por el idioma del usuario
        const filteredPromotions = response.data.response.promociones.filter(
          (promo) => promo.lang === i18n.language
        );
        setPromotions(filteredPromotions);
      } catch (error) {
        console.error("Error al cargar promociones:", error);
        setPromotions([
          {
            titulo: "Error",
            detalle:
              "No se pudo cargar la lista de bonos. Por favor, inténtalo de nuevo más tarde.",
            picture:
              "https://masterbets365.com/static/media/logo.291eacffcd58797e638642a6e44ed6b2.svg",
          },
        ]);
      }
    };

    loadPromociones();
  }, [i18n.language]);
  const getImageUrl = (picture) => {
    return `https://admin.betsfactory.co/admin/contenido/${i18n.language}/promociones/${picture}`;
  };

  const discountArrayUpdated = promotions.map((promo) => ({
    
    title: promo.titulo,
    description: promo.detalle,
    imageUrl: getImageUrl(promo.picture),
  }));
  
  const handleModalOpen = (promo, index) => {
    setSelectedPromotion(promo);
    setSelectedPromotionIndex(index);
  };

  const handleModalClose = () => {
    setSelectedPromotion(null);
    setSelectedPromotionIndex(null);
  };

  return (
    <WitgetContainer>
      {props.loading && <LoaderFull />}
      {discountArrayUpdated.length >= 1 ? <StyledSlider {...settings} {...props}>
        {discountArrayUpdated.map((promo, i) => (
          <MultiItemscolumn key={i}>
            <MultiItemsCard
              style={{
                backgroundImage: `url("${promo.imageUrl}")`,
              }}
            >
              <ContentCardImage>
                <button
                  className="btnplay"
                  onClick={() => handleModalOpen(promo, i)}
                >
                 {t(`home.watch-now`)}
                </button>
              </ContentCardImage>
            </MultiItemsCard>
          </MultiItemscolumn>
        ))}
      </StyledSlider> : ""}
      
      {selectedPromotion && (
        <DetailModal
          open={true}
          handleClose={handleModalClose}
          title={selectedPromotion.title}
          description={selectedPromotion.description}
          imageUrl={selectedPromotion.imageUrl}
          index={selectedPromotionIndex}
          discountArray={promotions}
        />
      )}
    </WitgetContainer>
  );
};

export default Banner2;
